<template>
<!-- eslint-disable max-len -->
<div
  class="progress-bar-background"
>
  <div
    v-if="group != null && group.teamDecisions != null"
    class="progress-bar-foreground"
    :style="`width: ${myProgress}%;`"
  />
  <tooltip
    target="progressBar"
  >
  </tooltip>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import Tooltip from './Tooltip';

export default {
  components: {
    Tooltip,
  },
  computed: {
    ...mapGetters([
      'group',
      'myProgress'
    ])
  }
};
</script>

<style lang="scss" scoped>
.progress-bar-background {
  background-color: var(--progressBarBackgroundColor);
  border: 2px solid rgba(0, 0, 0, 0.75);
  width: 98%;
  position: absolute;
  bottom: 10px;
  right: 1%;
  height: 9px;
  padding: 0;
}

.progress-bar-foreground {
  background-color: var(--progressBarForegroundColor);
  margin-top: 1px;
  height: 4px;
  transition: width 0.75s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/ProgressBar.vue